import { Heart, ShieldCheck, Truck, MapPinned } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import TrustBar from '../components/TrustBar';

export default function About() {
  return (
    <>
      <SEO title="About Us — Family-Run Removals in London | Laraé Logistics"
        description="Laraé Logistics is a family-run, fully insured removals company covering London and the rest of the UK. Learn about our story, our team and our commitment to careful, honest moving." />
      <section className="bg-forest text-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 max-w-3xl">
          <p className="font-manrope text-sm text-oat uppercase tracking-widest mb-3">About us</p>
          <h1 className="font-outfit text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight">A family business that treats your home like ours.</h1>
        </div>
      </section>
      <TrustBar />
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-5 md:px-8 lg:px-12 prose prose-lg">
          <p className="font-manrope text-lg text-ink/80 leading-relaxed">
            Laraé Logistics started with one van, one phone, and a simple idea: removals can be done properly without the price tags and call-centre experience of bigger national firms.
          </p>
          <p className="font-manrope text-base text-ink/70 mt-5 leading-relaxed">
            We're a small, family-run team. Every job is handled by trained, vetted movers — not subcontractors — and every quote is fixed before we arrive. Our crews load and unload with the care they'd give their own homes.
          </p>
          <p className="font-manrope text-base text-ink/70 mt-5 leading-relaxed">
            We cover all of London and Greater London for local moves, and undertake long-distance and nationwide moves throughout the UK. Whether it's a single sofa or a four-bedroom family home, the same standards apply.
          </p>
        </div>
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-4 gap-5 mt-16">
          {[
            { i: Heart, t: 'Family-run', d: 'Owned and operated by the same family from day one.' },
            { i: ShieldCheck, t: 'Fully insured', d: '£10k Goods in Transit + £1M Public Liability.' },
            { i: Truck, t: 'Modern fleet', d: 'Luton vans, 3.5T trucks, and packing supplies on board.' },
            { i: MapPinned, t: 'London &amp; UK-wide', d: 'Local crews for London, nationwide moves anywhere in the UK.' },
          ].map(({ i: Icon, t, d }) => (
            <div key={t} className="bg-white border border-sand rounded-2xl p-6">
              <Icon size={22} className="text-forest mb-4" />
              <div className="font-outfit text-lg font-semibold text-ink">{t}</div>
              <div className="font-manrope text-sm text-ink/65 mt-2 leading-relaxed" dangerouslySetInnerHTML={{ __html: d }} />
            </div>
          ))}
        </div>
        <div className="text-center mt-14">
          <Link to="/quote" className="bg-forest text-white font-semibold rounded-full px-7 py-4 inline-flex items-center justify-center gap-2">Get Free Quote</Link>
        </div>
      </section>
    </>
  );
}
